export const MA_REGISTRATION_LOADER = {
  desktop: `<div class="cui-grid">
  <div class="cui-container">
    <div class="cui-row">
      <div class="cui-col-sm cui-col-md-5 cui-col-lg-8 cui-col-xl-6 cui-col-xxl-5 col-offset-xl-1 -spacing--bottom-40 -spacing--top-64">
        <div class="cui-skeleton-heading -size--large -resolution--desktop -spacing--bottom-40">
          <div class="cui-skeleton-heading__content" style="width: max(300px, 100%);">
              <div class="cui-skeleton__item cui-skeleton-heading__title"></div>
              <div class="cui-skeleton__item cui-skeleton__description"></div>
              <div class="cui-skeleton__item cui-skeleton__description"></div>
          </div>
        </div>
        <div class="cui-skeleton-heading -size--medium -resolution--desktop -spacing--bottom-24">
          <div class="cui-skeleton-heading__content" style="width: max(300px, 100%);">
              <div class="cui-skeleton__item cui-skeleton-heading__title"></div>
          </div>
        </div>
        <div class="cui-skeleton-input -size--medium -spacing--bottom-24">
          <div class="cui-skeleton-input__content" style="width: max(64px, 100%);">
              <div class="cui-skeleton__item cui-skeleton-input__label"></div>
              <div class="cui-skeleton__item cui-skeleton-input__field"></div>
          </div>
        </div>
        <div class="cui-skeleton-input -size--medium -spacing--bottom-24">
          <div class="cui-skeleton-input__content" style="width: max(64px, 100%);">
              <div class="cui-skeleton__item cui-skeleton-input__label"></div>
              <div class="cui-skeleton__item cui-skeleton-input__field"></div>
          </div> 
        </div>
        <div class="cui-skeleton-input -size--medium -spacing--bottom-24">
          <div class="cui-skeleton-input__content" style="width: max(64px, 100%);">
              <div class="cui-skeleton__item cui-skeleton-input__label"></div>
              <div class="cui-skeleton__item cui-skeleton-input__field"></div>
          </div>
        </div>
        <div class="cui-skeleton-input -size--medium -spacing--bottom-40">
          <div class="cui-skeleton-input__content" style="width: max(64px, 100%);">
              <div class="cui-skeleton__item cui-skeleton-input__label"></div>
              <div class="cui-skeleton__item cui-skeleton-input__field"></div>
          </div>
        </div>
        <div class="cui-skeleton-heading -size--medium -resolution--desktop -spacing--bottom-24">
          <div class="cui-skeleton-heading__content" style="width: max(300px, 100%);">
              <div class="cui-skeleton__item cui-skeleton-heading__title"></div>
          </div>
        </div>
        <div class="cui-skeleton-input -size--medium -spacing--bottom-24">
          <div class="cui-skeleton-input__content" style="width: max(64px, 100%);">
              <div class="cui-skeleton__item cui-skeleton-input__label"></div>
              <div class="cui-skeleton__item cui-skeleton-input__field"></div>
          </div>
        </div>
        <div class="cui-skeleton-input -size--medium -spacing--bottom-32">
          <div class="cui-skeleton-input__content" style="width: max(64px, 100%);">
              <div class="cui-skeleton__item cui-skeleton-input__label"></div>
              <div class="cui-skeleton__item cui-skeleton-input__field"></div>
          </div>
        </div>
        <div class="cui-skeleton-paragraph -size--large -resolution--desktop -spacing--bottom-40">
          <div class="cui-skeleton-paragraph__content" style="width: 300px;">
              <div class="cui-skeleton__item cui-skeleton__description"></div>
              <div class="cui-skeleton__item cui-skeleton__description"></div>
              <div class="cui-skeleton__item cui-skeleton__description"></div>
              <div class="cui-skeleton__item cui-skeleton__description"></div>
              <div class="cui-skeleton__item cui-skeleton__description"></div>
              <div class="cui-skeleton__item cui-skeleton__description"></div>
              <div class="cui-skeleton__item cui-skeleton__description"></div>
              <div class="cui-skeleton__item cui-skeleton__description"></div>
          </div>
        </div>
        <div class="cui-skeleton-heading -size--medium -resolution--desktop -spacing--bottom-24">
          <div class="cui-skeleton-heading__content" style="width: max(300px, 100%);">
              <div class="cui-skeleton__item cui-skeleton-heading__title"></div>
              <div class="cui-skeleton__item cui-skeleton__description -spacing--bottom-24"></div>
              <div class="cui-skeleton__item cui-skeleton__description"></div>
              <div class="cui-skeleton__item cui-skeleton__description"></div>
              <div class="cui-skeleton__item cui-skeleton__description"></div>
              <div class="cui-skeleton__item cui-skeleton__description"></div>
              <div class="cui-skeleton__item cui-skeleton__description -spacing--bottom-24"></div>
          </div>
        </div>
        <div class="cui-skeleton-paragraph -size--large -resolution--desktop -spacing--bottom-40">
          <div class="cui-skeleton-paragraph__content" style="width: max(300px, 30%);">
              <div class="cui-skeleton__item cui-skeleton__description"></div>
              <div class="cui-skeleton__item cui-skeleton__description"></div>
              <div class="cui-skeleton__item cui-skeleton__description"></div>
              <div class="cui-skeleton__item cui-skeleton__description"></div>
          </div>
        </div>
        <div class="cui-skeleton-button -size--large">
          <div class="cui-skeleton-button__content" style="width: 120px;">
              <div class="cui-skeleton__item cui-skeleton-button__button"></div>
          </div>
        </div>
      </div>
      <div class="cui-col-md-3 cui-col-lg-4 cui-col-xl-4 col-offset-xl-1 col-offset-xxl-2 display-none display-md-block">
        <div class="cui-skeleton-rectangle -is--block -spacing--top-64 -spacing--bottom-16">
          <div class="cui-skeleton__item" style="width: 48px; height: 48px;"></div>
        </div>
        <div class="cui-skeleton-heading -size--medium -resolution--desktop -spacing--bottom-64">
          <div class="cui-skeleton-heading__content" style="width: max(150px, 100%);">
              <div class="cui-skeleton__item cui-skeleton-heading__title"></div>
              <div class="cui-skeleton__item cui-skeleton__description"></div>
              <div class="cui-skeleton__item cui-skeleton__description"></div>
          </div>
        </div>
        <div class="cui-skeleton-rectangle -is--block -spacing--top-40 -spacing--bottom-16">
          <div class="cui-skeleton__item" style="width: 48px; height: 48px;"></div>
        </div>
        <div class="cui-skeleton-heading -size--medium -resolution--desktop -spacing--bottom-64">
          <div class="cui-skeleton-heading__content" style="width: max(150px, 100%);">
              <div class="cui-skeleton__item cui-skeleton-heading__title"></div>
              <div class="cui-skeleton__item cui-skeleton__description"></div>
              <div class="cui-skeleton__item cui-skeleton__description"></div>
          </div>
        </div>
        <div class="cui-skeleton-rectangle -is--block -spacing--top-40 -spacing--bottom-16">
          <div class="cui-skeleton__item" style="width: 48px; height: 48px;"></div>
        </div>
        <div class="cui-skeleton-heading -size--medium -resolution--desktop -spacing--bottom-64">
          <div class="cui-skeleton-heading__content" style="width: max(150px, 100%);">
              <div class="cui-skeleton__item cui-skeleton-heading__title"></div>
              <div class="cui-skeleton__item cui-skeleton__description"></div>
              <div class="cui-skeleton__item cui-skeleton__description"></div>
          </div>
        </div>
        <div class="cui-skeleton-rectangle -is--block -spacing--top-40 -spacing--bottom-16">
          <div class="cui-skeleton__item" style="width: 48px; height: 48px;"></div>
        </div>
        <div class="cui-skeleton-heading -size--medium -resolution--desktop">
          <div class="cui-skeleton-heading__content" style="width: max(150px, 100%);">
              <div class="cui-skeleton__item cui-skeleton-heading__title"></div>
              <div class="cui-skeleton__item cui-skeleton__description"></div>
              <div class="cui-skeleton__item cui-skeleton__description"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>`
};
